import {
    Button,
    Checkbox,
    Dialog,
    FormControl,
    FormControlLabel,
    FormHelperText,
    SwipeableDrawer,
} from '@material-ui/core';
import { sendPhoneOTP } from '../../../../redux-store/actions/nct';
import { formatRtaResponse, isSipAllowed, isWeekdayNamedArray, sortSip, TRXN_TYPE_MAP } from '../utils';
import { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { RouteComponentProps, StaticContext } from 'react-router';
import en from '../../../../lang/en-us';
import { redeemScheme } from '../../../../redux-store/actions/commercialTransactions';
import { getNewSchemeDetail } from '../../../../redux-store/actions/commercialTransactions';
import {
    schemeDetailsRequestType,
    schemeDetailsResponseType,
    sipType,
    _schemeDetailsNewType,
} from '../../../../redux-store/types/commercialTransactions';
import { KYCCheck } from '../../../common/KYCCheck';
import { CommercialRootPath } from '../routeConfig';
import FatcaCheck from '../../../common/FatcaCheck';
import { SWPPaths } from './routes';
import { RedemptionAPIDataKeyType } from '../../../../redux-store/reducers/redemption';
import { installmentInitialValues } from '../STP/STPInvestment';
import { InvestLowerValidationScheme, parseToAPIStructure } from '../STP/utils';
import { useFormik } from 'formik';
import InstallmentFields from '../STP/InstallmentFields';
import { SubmitButtonWithLoader } from '../../../../lib/Button';
import { IsAllow } from '../../../../redux-store/types/portfolio';
import { DisplayBlock } from '../Redemption/HelperBlocks';
import { favLogos } from '../../../../logo/logos';
import { formatAsIndianCurrency } from '../../../../utils/currency';
import { SelectBank } from '../Redemption/SelectBank';
import { bankDetailsInitState, BankDetailsType } from '../../../../hooks/useBank';
import { idcwDetailsType } from '../IdcwOptions';
import { STPAPIRequestType, STPAPIResponseType, STPPaths } from '../STP/types';
import { RootStateType } from '../../../../redux-store/reducers';
import { OTP_ACTIONS } from '../../../../utils/constants';
import { decimalFix } from '../../portfolios/utils';
import { IFSCError } from '../IFSCError';
import { RtaSchemeLoadingDialog } from '../AdditionalPurchase/ap-invest';
import { PanSeedCheckNew } from '../../../common/PanSeedCheckNew';
import { NomineePopup } from '../../NomineePopup';

const { dbCommercial, common } = en;

type MatchParams = {
    folioNo: string;
};
type StateParams = {
    swpFolio?: any;
    reqId?: string;
    otpRef?: string;
    apiPayload?: STPAPIRequestType;
    amc?: string;
};
function SWPMain(
    props: RouteComponentProps<MatchParams, StaticContext, StateParams> & {
        getNewSchemeDetail: ({
            isin,
            amcCode,
        }: schemeDetailsRequestType) => Promise<schemeDetailsResponseType>;
        sendPhoneOTP: any;
    },
) {
    const { swpFolio } = props.location.state || {};
    if (!swpFolio) {
        props.history.replace(`${CommercialRootPath}${SWPPaths.SWP}`);
        return null;
    }
    const amcCode = new URLSearchParams(props.location.search).get('amc');
    const { userRegisteredWith, email, mobile } = useSelector(({ authReducer }: RootStateType) => ({
        userRegisteredWith: authReducer.userRegisteredWith,
        email: authReducer.email,
        mobile: authReducer.mobile,
    }));
    const {
        folio: folioNo,
        nav,
        availableAmount,
        availableUnits,
        amc,
        isin,
        schemeName,
        navDate,
        rtaName,
    } = swpFolio;

    const installmentFormik = useFormik({
        initialValues: installmentInitialValues,
        onSubmit: () => {},
        validationSchema: InvestLowerValidationScheme({ swpFlag: true }),
        validateOnMount: true,
    });

    const [show, setShow] = useState<boolean>(false);
    const [bankDetails, setBankDetails] = useState<BankDetailsType>(bankDetailsInitState); //setting bank details to default when no bank is available
    const [openDrawer, setDrawer] = useState<boolean>(false);
    const [installmentDiff, setInstallmentDiff] = useState<number>(1);
    const [swpDetails, setSwpDetails] = useState<sipType | null>(null);
    const [isChecked, setChecked] = useState<{ value: boolean; message: string }>({
        value: false,
        message: '',
    });
    const [loading, setLoading] = useState(false);
    const [schemeLoading, setSchemeLoading] = useState(false);
    const [ifscError, setIfscError] = useState(false);
    const [commonDetails, setCommonDetails] =
        useState<_schemeDetailsNewType['commonDetails'] | null>(null);

    useEffect(() => {
        async function getNewSchemeDetails() {
            try {
                setSchemeLoading(true);
                const { body = { data: {} as any } }: any = await props.getNewSchemeDetail({
                    isin,
                    amcCode: !!amcCode ? amcCode : '',
                });
                const details = formatRtaResponse(body.data);
                //[TODO: Add default values to SIP]
                const { sip: swp = null, bool: sipAllow } = isSipAllowed(details.swp);
                sortSip(swp);
                setSwpDetails(swp);
                setCommonDetails({
                    ...details.commonDetails,
                    sipAllow:
                        details.commonDetails.sipAllow === IsAllow.YES
                            ? sipAllow
                            : details.commonDetails.sipAllow,
                });
                installmentFormik.setFieldValue('frequency', Object.keys(swp)[0]);
            } catch (err: any) {
                alert(err.message);
            } finally {
                setSchemeLoading(false);
            }
        }
        getNewSchemeDetails();
    }, []);

    const handleSubmit = async () => {
        if (!isChecked.value) {
            setChecked({ value: false, message: dbCommercial.errors.termsAndCondition });
        }
        if (commonDetails?.swpAllow === IsAllow.No) {
            alert(dbCommercial.swp.notAllowed);
            return;
        }
        if (!bankDetails.ifsc) {
            setIfscError(true);
            return;
        }
        installmentFormik.submitForm();
        if (installmentFormik.isValid && isChecked.value) {
            const idcwFields: idcwDetailsType = {
                idcwOption: '',
                isin: swpFolio.isin,
            };
            const apiBody = parseToAPIStructure(installmentFormik, swpFolio);
            try {
                const sipDayList = swpDetails?.[installmentFormik.values.frequency as string]?.dates || [];
                const isWeekdayBased = sipDayList.length > 0 && isWeekdayNamedArray(sipDayList);
                const isAllDates = sipDayList?.length === 1 && sipDayList[0]?.toLowerCase() === 'all';
                if (
                    !isWeekdayBased && !isAllDates &&
                    String(installmentFormik.values.installmentDay) !==
                    String(installmentFormik.values.fromDate.getDate())
                ) {
                    throw new Error('SWP Day and start date are different');
                }
                if (installmentDiff % 1 !== 0 && !installmentFormik.values.perpetual) {
                    throw new Error('Invalid Installment');
                }
                if (Number(installmentFormik.values.amount) > swpFolio.availableAmount) {
                    throw new Error(dbCommercial.switch.switchFromAmountError);
                }
                setLoading(true);
                const otpPayload = {
                    action: OTP_ACTIONS.swp,
                };
                const res = await props.sendPhoneOTP(otpPayload);
                props.history.replace(`${CommercialRootPath}${SWPPaths.otp}`, {
                    reqId: res.body.reqId,
                    otpRef: res.body.otpRef,
                    apiPayload: apiBody,
                });
            } catch (err: any) {
                alert(err.message);
            } finally {
                setLoading(false);
            }
        }
    };
    return (
        <div className="curved-bg mf-investment mf-payment">
            <KYCCheck allowRegistration={{ isin, amc }} />
            <PanSeedCheckNew
                customPayload={{
                    taxStatus: swpFolio.taxStatus,
                    amc: amc,
                    folio: swpFolio.folio,
                    trxnMode: 'FT',
                    trxnType: TRXN_TYPE_MAP.swp,
                }}
                callBackFn={() => {}}
                triggerCheck={true}
            />
            <FatcaCheck rtaName={rtaName} />
            <h2 className="heading">
                <a onClick={() => props.history.goBack()}>
                    <img src="/images/left-arrow-black.svg" alt="icon" />
                </a>
                {dbCommercial.swp.heading}
            </h2>
            <div className="mobile-profile-details mobile_mode" style={{ marginTop: 0 }}>
                <div className="mobile-profile-details-inner">
                    <h4>{dbCommercial.swp.swpDetails}</h4>
                    <div className="mobile-profile-details-links">
                        <a onClick={() => setDrawer(true)}>
                            View <img src="/images/right-arrow-purple.svg" alt="icon" />
                        </a>
                    </div>
                </div>
            </div>
            <div className="curved-bg-content">
                <div className="mf-investment-left">
                    <div className="investment-mode">
                        <div className="investment-details">
                            <h3>
                                <img src="/images/investment-details.svg" alt="icon" />
                                {dbCommercial.exploreMfs.mfInvestment.investmentDetails}
                            </h3>
                            <InstallmentFields
                                rtaName={rtaName}
                                formik={installmentFormik}
                                schemeDetails={swpDetails}
                                setInstallmentDiff={setInstallmentDiff}
                                swpFlag={true}
                                amc={amc}
                            />
                            <div className="mf-investment-bottom">
                                <div className="disclaimers">
                                    <FormControl>
                                        <FormControlLabel
                                            className="inline-checkbox"
                                            control={
                                                <Checkbox
                                                    name="terms-conditions"
                                                    onChange={() =>
                                                        setChecked((prevState) => ({
                                                            value: !prevState.value,
                                                            message: !!prevState.value
                                                                ? dbCommercial.errors
                                                                      .termsAndCondition
                                                                : '',
                                                        }))
                                                    }
                                                    checked={isChecked.value}
                                                    disabled={loading}
                                                />
                                            }
                                            label={
                                                <>
                                                    {
                                                        dbCommercial.exploreMfs.mfInvestment
                                                            .disclaimers
                                                    }
                                                    <a onClick={() => setShow(!show)}>
                                                        {
                                                            dbCommercial.exploreMfs.mfInvestment
                                                                .termsLink
                                                        }
                                                    </a>
                                                    {dbCommercial.exploreMfs.mfInvestment.of}
                                                    <span>
                                                        {
                                                            dbCommercial.exploreMfs.mfInvestment
                                                                .mfCentral
                                                        }
                                                    </span>
                                                </>
                                            }
                                        />
                                        <FormHelperText
                                            style={{
                                                color: 'red',
                                                fontSize: 14,
                                                textAlign: 'left',
                                            }}
                                        >
                                            {isChecked.message}
                                        </FormHelperText>
                                    </FormControl>
                                </div>
                                <div className="buttons">
                                    <SubmitButtonWithLoader
                                        className="customBtn"
                                        onClick={handleSubmit}
                                        label={dbCommercial.redemption.proceedBtn}
                                        loading={loading}
                                        labelWhileLoading="Proceeding..."
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mf-investment-right redemption-right">
                    <div className="heading">
                        <h4>
                            {dbCommercial.swp.swpDetails}{' '}
                            <img src="/images/rupee-coin.png" alt="icon" />
                        </h4>
                        <div className="profile-details">
                            <div className="profile-details-info">
                                <p> {dbCommercial.redemption.selectedFolio}</p>
                                <h6>{folioNo}</h6>
                            </div>
                        </div>
                        <p>
                            <img src={`/images/fav-logos/${favLogos[amc]}.svg`} alt="icon" />
                            <h5>{schemeName}</h5>
                        </p>
                    </div>
                    <div className="profile-details">
                        <DisplayBlock
                            title={dbCommercial.redemption.currentValue}
                            value={`₹${availableAmount}`}
                        />
                        <DisplayBlock
                            title={dbCommercial.redemption.totalBalanceUnits}
                            value={`${availableUnits}`}
                        />
                        <div className="profile-details-info current-nav">
                            <p>{dbCommercial.redemption.currentNav}</p>
                            <div>
                                <h6>{`${formatAsIndianCurrency(nav)}`}</h6>
                                <p>
                                    <img src="/images/calender-icon.svg" alt="icon" />
                                    {dbCommercial.redemption.asOn}
                                    <b>{navDate}</b>
                                </p>
                            </div>
                        </div>
                    </div>
                    <SelectBank
                        folioNo={folioNo}
                        amc={swpFolio?.amc}
                        handleBankDetails={setBankDetails}
                        redemptionFlag={true}
                    />
                </div>
                <Dialog
                    open={false}
                    onClose={() => history.back()}
                    maxWidth={'sm'}
                    aria-labelledby="transmission-main-modal"
                >
                    <div className="note-modals transmission-main-modal">
                        <h3>{dbCommercial.exploreMfs.inactiveScheme}</h3>
                        <p>{dbCommercial.exploreMfs.inactiveSchemeInfo}</p>
                        <div className="note-modals-btns">
                            <Button className="customBtn" onClick={() => history.back()}>
                                {dbCommercial.exploreMfs.okay}
                            </Button>
                        </div>
                    </div>
                </Dialog>
            </div>
            <IFSCError open={ifscError} setOpen={setIfscError} />
            <Dialog fullWidth maxWidth={'lg'} open={show} aria-labelledby="terms-modal">
                <div className="terms-modal">
                    <div className="heading">
                        <h2>{common.termsConditions}</h2>
                        <a className="close">
                            <img
                                onClick={() => setShow(!show)}
                                src="/images/close-white.svg"
                                alt="icon"
                            />
                        </a>
                    </div>
                    <div className="content-outer">
                        <div className="content-inner">
                            <p>{dbCommercial.termsModal.redemption.info1}</p>
                            <p>{dbCommercial.termsModal.redemption.info2}</p>
                            <p>
                                <b>{dbCommercial.termsModal.redemption.note}</b>
                                {dbCommercial.termsModal.redemption.info3}
                            </p>
                        </div>
                    </div>
                </div>
            </Dialog>
            <RtaSchemeLoadingDialog open={schemeLoading} />
            <SwipeableDrawer
                anchor={'bottom'}
                open={openDrawer}
                onClose={() => setDrawer(false)}
                onOpen={() => setDrawer(true)}
                className="explore-mf-drawer profile-details-drawer"
            >
                <div className="filters-drawer-total">
                    <div className="filters-top">
                        <h5>
                            <img
                                src="/images/right-arrow-long-black.svg"
                                alt="icon"
                                onClick={() => setDrawer(false)}
                            />
                            {dbCommercial.swp.swpDetails}
                        </h5>
                    </div>
                    <div className="filters-drawer-content">
                        <div className="profile-details-drawer">
                            <div className="heading">
                                <div className="profile-details">
                                    <div className="profile-details-info">
                                        <p> {dbCommercial.redemption.selectedFolio}</p>
                                        <h6>{folioNo}</h6>
                                    </div>
                                </div>
                                <p>
                                    <img
                                        src={`/images/fav-logos/${favLogos[amc]}.svg`}
                                        alt="icon"
                                    />
                                    <h5>{schemeName}</h5>
                                </p>
                            </div>
                            <div className="profile-details">
                                <DisplayBlock
                                    title={dbCommercial.redemption.currentValue}
                                    value={`₹${decimalFix(availableAmount)}`}
                                />
                                <DisplayBlock
                                    title={dbCommercial.redemption.totalBalanceUnits}
                                    value={`${decimalFix(availableUnits)}`}
                                />
                                <div className="profile-details-info current-nav">
                                    <p>{dbCommercial.redemption.currentNav}</p>
                                    <div>
                                        <h6>{`${formatAsIndianCurrency(nav)}`}</h6>
                                        <p>
                                            <img src="/images/calender-icon.svg" alt="icon" />
                                            {dbCommercial.redemption.asOn}
                                            <b>{navDate}</b>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <SelectBank
                                folioNo={folioNo}
                                amc={swpFolio?.amc}
                                handleBankDetails={setBankDetails}
                            />
                        </div>
                    </div>
                </div>
            </SwipeableDrawer>
            <NomineePopup />
        </div>
    );
}

export default connect(null, {
    redeemScheme,
    getNewSchemeDetail,
    sendPhoneOTP,
})(SWPMain);
